export default __webpack_public_path__ + "static/media/logo.2c912d08.png";